import styled from '@emotion/styled';
import { Avatar } from '@material-ui/core';

export const PaperThreadHeader = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  justify-content: space-between;
  width: 100%;
`;

export const DrawerThreadHeader = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const HeaderAvater = styled(Avatar)`
  width: 36px;
  height: 36px;
  margin-right: 14px;
`;

export const HeaderUserName = styled('a')`
  margin-right: 8px;
  font-size: 14px;
  color: #006bd6;
  text-decoration: none;
`;

export const HeaderDate = styled('span')`
  font-size: 10px;
  color: #707889;
`;

export const ThreadItemWrapper = styled('div')(`
  display: flex;
  flex-direction: column;
  width: 100%;
`);

export const Paragraph = styled('div')(`
  font-size: 14px;
  line-height: 160%;
  white-space: pre-wrap;
  margin-top: 8px;
  overflow-wrap: anywhere;
`);

export const ThreadImageWrapper = styled('div')`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
`;

export const ThreadImage = styled('div')`
  max-width: 240px;
`;

export const AttachableAttachmentWrapper = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const AttachableAttachment = styled('a')`
  text-decoration: none;
  width: fit-content;
  color: #006bd6;
`;
